import React, { useState } from "react";
import { Container } from "../../Utils/Container/Container";
import { Header } from "../../components/Header/Header";
import ReportTitleBar from "../../components/ReportTitleBar/ReportTitleBar";
import InfoBlock from "../../components/InfoBlock/InfoBlock";
import ActivitiesTable from "../../components/ActivitiesTable/ActivitiesTable";
import ReportButtons from "../../components/ReportButtons/ReportButtons";
import './ReportPage.css';

const parseTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
};

const parseDateTime = (dateTimeStr) => {
    // Assuming format "DD.MM.YYYY HH:mm"
    const parts = dateTimeStr.split(' ');
    const dateParts = parts[0].split('.');
    const timeParts = parts[1].split(':');
    // new Date(year, monthIndex, day, hours, minutes)
    return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1]);
};

const ReportPage = () => {
    const [formData, setFormData] = useState({
        titleBar: {
            nr: '224488',
            datum: new Date(),
            einsatzleiter: 'POM Max Mustermann'
        },
        informationen: [
            { infoKey: 'Beginn (Plan)', infoValue: parseDateTime('25.01.2022 08:00') },
            { infoKey: 'Ende (Plan)', infoValue: parseDateTime('25.01.2022 14:00') },
            { infoKey: 'Beginn (Ist)', infoValue: parseDateTime('25.01.2022 08:00') },
            { infoKey: 'Ende (Ist)', infoValue: parseDateTime('25.01.2022 13:21') },
            { infoKey: 'Status', infoValue: 'In Arbeit' },
            { infoKey: 'Sprache', infoValue: 'Englisch' },
            { infoKey: 'Dol. ID', infoValue: '49242' },
            { infoKey: 'Dol. Name', infoValue: 'Mustermann' },
            { infoKey: 'Dol. Vorname', infoValue: 'Maria' },
            { infoKey: 'Büro', infoValue: '—' },
        ],
        einsatzort: [
            { infoKey: 'Einsatzort', infoValue: 'Flughafen München' },
            { infoKey: 'Zusatz', infoValue: 'Außenstelle' },
            { infoKey: 'E-Mail', infoValue: 'vv@xxx.yyyy.de' },
            { infoKey: 'Telefon', infoValue: '+49 89 94326457' },
            { infoKey: 'Postleitzahl', infoValue: '85356' },
            { infoKey: 'Ort', infoValue: 'München Flughafen' },
            { infoKey: 'Straße', infoValue: 'Nordallee' },
            { infoKey: 'Hausnummer', infoValue: '25' },
        ],
        abrechnungsdaten: [
            { infoKey: 'Arbeitszeit', infoValue: '04:53' },
            { infoKey: 'Wartezeit', infoValue: '00:28' },
            { infoKey: 'Pause / Unterbrechung', infoValue: '—' },
            { infoKey: 'Einsatzdauer', infoValue: '05:21' },
            { infoKey: 'Vergütung', infoValue: '165,85 €' },
            { infoKey: 'Fahrtkostenausgleich', infoValue: '57,51 €' },
            { infoKey: 'Übernachtungspauschale', infoValue: '—' },
            { infoKey: 'Umsatzsteuer', infoValue: '42,44 €' },
            { infoKey: 'Gesamtbetrag', infoValue: '265,80 €' },
            { infoKey: 'Stundensatz', infoValue: '31,00' },
        ],
        activities: [
            { planzeitStart: parseTime('08:15'), planzeitEnd: parseTime('09:50'), istzeitStart: parseTime('08:15'), istzeitEnd: parseTime('09:50'), einsatzart: 'Aktenanlage', sprache: 'English' },
            { planzeitStart: parseTime('10:00'), planzeitEnd: parseTime('10:50'), istzeitStart: parseTime('10:00'), istzeitEnd: parseTime('10:50'), einsatzart: 'Aktenanlage', sprache: 'English' },
            { planzeitStart: parseTime('10:50'), planzeitEnd: parseTime('12:18'), istzeitStart: parseTime('10:50'), istzeitEnd: parseTime('12:18'), einsatzart: 'Anhörung', sprache: 'Français' },
            { planzeitStart: parseTime('12:18'), planzeitEnd: parseTime('13:14'), istzeitStart: parseTime('12:18'), istzeitEnd: parseTime('13:14'), einsatzart: 'Anhörung', sprache: 'Español' },
            { planzeitStart: parseTime('13:17'), planzeitEnd: parseTime('13:21'), istzeitStart: parseTime('13:17'), istzeitEnd: parseTime('13:21'), einsatzart: 'Vor-Ort-Übersetzung (schriftlich)', sprache: 'Italiano' },
        ],
    });

    const handleTitleBarChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            titleBar: {
                ...prev.titleBar,
                [name]: value
            }
        }));
    };

    const handleTitleBarDateChange = (date) => {
        setFormData(prev => ({
            ...prev,
            titleBar: {
                ...prev.titleBar,
                datum: date
            }
        }));
    };

    const handleInfoBlockChange = (e, index, blockName) => {
        const { value } = e.target;
        const updatedBlock = [...formData[blockName]];
        updatedBlock[index] = { ...updatedBlock[index], infoValue: value };
        setFormData(prev => ({
            ...prev,
            [blockName]: updatedBlock
        }));
    };

    const handleInfoBlockDateChange = (date, index, blockName) => {
        const updatedBlock = [...formData[blockName]];
        updatedBlock[index] = { ...updatedBlock[index], infoValue: date };
        setFormData(prev => ({
            ...prev,
            [blockName]: updatedBlock
        }));
    };

    const handleActivityChange = (e, index) => {
        const { name, value } = e.target;
        const updatedActivities = [...formData.activities];
        updatedActivities[index] = { ...updatedActivities[index], [name]: value };
        setFormData(prev => ({
            ...prev,
            activities: updatedActivities
        }));
    };
    
    const handleActivityDateChange = (date, index, name) => {
        const updatedActivities = [...formData.activities];
        updatedActivities[index] = { ...updatedActivities[index], [name]: date };
        setFormData(prev => ({
            ...prev,
            activities: updatedActivities
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted", formData);
        // Here you would typically send the data to a server
    };

    const handlePrint = () => {
        // Open the browser's print dialog for the current page
        window.print();
    };

    return (
        <Container>
            <Header />
            <div className="report-page-wrapper">
                <form onSubmit={handleSubmit}>
                    <ReportTitleBar 
                        data={formData.titleBar} 
                        onChange={handleTitleBarChange} 
                        onDateChange={handleTitleBarDateChange}
                    />
                    <div className="info-blocks-container">
                        <InfoBlock 
                            icon="icon-info" 
                            title="Informationen zum Einsatz" 
                            data={formData.informationen} 
                            onDataChange={(e, index) => handleInfoBlockChange(e, index, 'informationen')} 
                            onDateChange={(date, index) => handleInfoBlockDateChange(date, index, 'informationen')}
                        />
                        <InfoBlock 
                            icon="icon-location" 
                            title="Einsatzort" 
                            data={formData.einsatzort} 
                            onDataChange={(e, index) => handleInfoBlockChange(e, index, 'einsatzort')} 
                        />
                        <InfoBlock 
                            icon="icon-euro" 
                            title="Abrechnungsdaten" 
                            data={formData.abrechnungsdaten}
                            onDataChange={(e, index) => handleInfoBlockChange(e, index, 'abrechnungsdaten')} 
                        />
                    </div>
                    <ActivitiesTable 
                        activities={formData.activities} 
                        onActivityChange={handleActivityChange} 
                        onActivityDateChange={handleActivityDateChange}
                    />
                    <ReportButtons onPrint={handlePrint} />
                </form>
            </div>
        </Container>
    );
};

export default ReportPage; 
